import React from 'react';
import { Navbar, Footer, AnnouncementBar } from "../components";

const Cookies = () => (
  <>
    <AnnouncementBar />
    <Navbar />
    <div className="container my-4">
      <h2>Cookies Policy</h2>
      <p>We use cookies to remember your preferences and improve site performance. You can control cookies in your browser settings.</p>
      <ul>
        <li>Essential cookies are required for cart and checkout.</li>
        <li>Analytics help us understand usage and improve UX.</li>
      </ul>
    </div>
    <Footer />
  </>
);

export default Cookies;
